import React, { useMemo } from 'react';
import styles from './RewardProgressView.module.scss';
import RewardsInfoBox from '../../assets/imgs/rewards-bg.png';
import RewardsInfoBoxSlash from '../../assets/imgs/rewards-slash.png';
import TickIcon from '../../assets/icons/icon-yes\ 1.png';
import { useTranslation } from 'react-i18next';
import TreasureChestBadge from '../../assets/imgs/treasure_chest_badge.png';

const RewardProgressView = (props) => {
    const { currentIteration, remainingDays, claimed, sevenDayBonus, claimedAllThisMonth, endOfMonthDate } = props;
    const [t] = useTranslation();
    
    const barDotsOnDays = useMemo(() => {
        let days = [1];
        Object.keys(sevenDayBonus).forEach((day) => {
            if (day % 7 === 0 || day == endOfMonthDate) {
                days.push(parseInt(day));
            }
        })
        return days;
    }, [sevenDayBonus]);

    return (
        <div className={styles.reward_container}>
            <div className={`${styles.rewards_container_text} ${claimedAllThisMonth ? styles.less_opacity : ''}`}>{t('BONUS_REWARDS_JOURNEY')}</div>
            <div className={`${styles.progress_bar_container} ${claimedAllThisMonth ? styles.less_opacity : ''}`}>
                <div className={styles.progress_bar_filler}
                    style={{ width: `${
                        currentIteration > 28 ? (
                            claimed ?
                                80 + (currentIteration - 28) / (endOfMonthDate - 28) * 20 :
                                80 + ((currentIteration-1)  - 28) / (endOfMonthDate - 28) * 20
                        ) : (
                            claimed ?
                                (currentIteration / 28) * 80 :
                                ((currentIteration-1) / 28) * 80
                        )
                    }%` }}
                ></div>

                <div className={styles.bar_steps_container}>
                    {
                        barDotsOnDays.map((day, index) => (
                            <div className={styles.bar_steps} key={index}>
                                {
                                    day > 1 ?
                                        currentIteration + remainingDays >= day ?
                                            <div
                                                className={styles.rewards_info_box}
                                                style={{
                                                    backgroundImage: `url(${RewardsInfoBox})`,
                                                    color: currentIteration >= day && claimed ? '#C3A689' : '',
                                                    width: ((day === 28 && endOfMonthDate === 28) || day > 28) ? '96px' : ''
                                                }}
                                            >
                                                <div className={styles.tokens}>
                                                    <img src={sevenDayBonus[day].image} className={styles.token_image} alt="map" />
                                                    <span>{sevenDayBonus[day].type}</span>
                                                    {currentIteration > day || (currentIteration === day && claimed) ?
                                                        <img src={TickIcon} className={styles.tick_image} alt="tick" /> :
                                                        ''}
                                                    {(day === 28 && endOfMonthDate === 28) &&
                                                        <>
                                                            <span style={{ margin: "2px" }}>+</span>
                                                            <img src={TreasureChestBadge} alt="treasure-chest-badge" />
                                                        </>
                                                    }
                                                </div>
                                                <div className={styles.days}>{t('DAY')} {day}</div>
                                            </div> :
                                            <div
                                                className={styles.rewards_info_box}
                                                style={{
                                                    backgroundImage: `url(${RewardsInfoBoxSlash})`,
                                                    color: '#7E654B',
                                                    width: ((day === 28 && endOfMonthDate === 28) || day > 28) ? '96px' : ''
                                                }}
                                            >
                                                <div className={styles.tokens}>
                                                    <img src={sevenDayBonus[day].image} className={styles.token_image} alt="map" style={{ filter: 'brightness(50%)' }} />
                                                    <span>{sevenDayBonus[day].type}</span>
                                                </div>
                                                <div className={styles.days}>{t('DAY')} {day}</div>
                                            </div> :
                                        ''
                                }
                                <div className={styles.step} style={{ background: currentIteration > day || (currentIteration === day && claimed) || (currentIteration === endOfMonthDate && claimed) ? '#ECBB50' : '' }}></div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export {RewardProgressView}
